// test689
(689 && 0);
